import * as textsTypes from '../types/Texts';
import {INITIAL_STATE} from './state/Texts';


export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case textsTypes.GET_TEXTS_SUCCESS:
            return {
                ...state,
                texts: action.payload
            };
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Texts.js